// Tenant document library (table `document`): files an admin manages in the portal and the
// backend attaches to outgoing mails. A quote references documents by id (table
// `quote_document`), never by file name. Replacing a file creates a new row and archives the
// old one, so a quote keeps pointing at the exact bytes its client received.

// Value + merged type (see TenantSettingKey): the generated api client re-exports names as
// runtime values.
export const DocumentCategory = {
    quoteAttachment: 'quote_attachment',
} as const;
export type DocumentCategory = (typeof DocumentCategory)[keyof typeof DocumentCategory];

export const DocumentLanguage = {
    nl: 'nl',
    fr: 'fr',
    en: 'en',
} as const;
export type DocumentLanguage = (typeof DocumentLanguage)[keyof typeof DocumentLanguage];

export interface IDocumentEntity {
    document_id: number;
    category: DocumentCategory;
    // Display name in pickers and settings; the file name is what the recipient sees.
    label: string;
    file_name: string;
    mime_type: string;
    size_bytes: number;
    sha256: string;
    // Null = language-independent (terms and conditions).
    language: DocumentLanguage | null;
    sequence: number;
    // Goes on every mail of the category, whether or not the quote selected it.
    always_attach: boolean;
    // Inactive documents can no longer be selected; quotes that already reference them keep them.
    active: boolean;
    creation_date: Date;
    created_by_user_id: number | null;
    // Set when a newer upload superseded this row.
    replaced_by_document_id: number | null;
    // Read-only: whether any quote references this document.
    in_use?: boolean;
}

export interface IDocumentUpdate {
    label?: string;
    language?: DocumentLanguage | null;
    always_attach?: boolean;
    active?: boolean;
}

export interface IDocumentReorder {
    category: DocumentCategory;
    ordered_ids: number[];
}

export const DOCUMENT_LABEL_MAX_LENGTH = 120;
// Only PDFs for now: brochures, technical sheets, terms. Widen deliberately, with a magic-byte
// check per type, rather than trusting the client's content type.
export const DOCUMENT_ALLOWED_MIME_TYPES = ['application/pdf'] as const;
export const DOCUMENT_MAX_FILE_BYTES = 4 * 1024 * 1024;
